export default "__VITE_ASSET__21300d78__"